import { render, staticRenderFns } from "./DropdownLight.vue?vue&type=template&id=55ef3ef4"
import script from "./DropdownLight.vue?vue&type=script&lang=js"
export * from "./DropdownLight.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports